import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  warehouseHeader: {
    description: 'Inventory locations grid warehouse header',
    defaultMessage: 'Warehouse',
    id: 'v/HKdn',
  },
  locationHeader: {
    description: 'Inventory locations grid warehouse location header',
    defaultMessage: 'Location',
    id: '49tQ7T',
  },
  lotIDHeader: {
    description: 'Inventory locations grid warehouse lot ID header',
    defaultMessage: 'Lot ID',
    id: 'Hi0h8F',
  },
  expirationDateHeader: {
    description: 'Inventory locations grid warehouse expiration date header',
    defaultMessage: 'Exp Date',
    id: 'rNIDDc',
  },
  onHandHeader: {
    description: 'Inventory locations grid on hand header',
    defaultMessage: 'On Hand',
    id: 'tjCQSu',
  },
  allocatedHeader: {
    description: 'Inventory locations grid allocated header',
    defaultMessage: 'Allocated',
    id: 'uXeXm8',
  },
  availableHeader: {
    description: 'Inventory locations grid available header',
    defaultMessage: 'Available',
    id: 'o4ig8G',
  },
  actionsHeader: {
    description: 'Inventory locations grid actions header',
    defaultMessage: 'Actions',
    id: '15d4jL',
  },
  moveLink: {
    description: 'Inventory locations grid move inventory link',
    defaultMessage: 'Move',
    id: 'e2DXZ0',
  },
  historyLink: {
    description: 'Inventory locations grid history link',
    defaultMessage: 'History',
    id: 'ewmHqh',
  },
  locationsFooterLink: {
    description: 'Inventory locations footer link',
    defaultMessage: 'Add Stock to Location',
    id: 'd9MfV/',
  },
  locationsFooterLinkInactiveProduct: {
    description: 'Inventory locations footer link for inactive product',
    defaultMessage: 'An inactive or deleted product cannot have stock. Mark this product active and save to add stock to it',
    id: '7g+GEj',
  },
  addStockButton: {
    description: 'Add Stock Inventory Button',
    defaultMessage: 'Add Stock',
    id: '6spPXr',
  },
  inventoryHistoryButton: {
    description: 'Inventory History Button',
    defaultMessage: 'View Stock History',
    id: 'q6BPo3',
  },
  toggleInventoryTracking: {
    description: 'Inventory tracking checkbox label',
    defaultMessage: 'Do Not Track Inventory',
    id: 'KvYSKq',
  },
  trackInventoryLabel: {
    description: 'Track inventory toggle label in V3 inventory tab',
    defaultMessage: 'Track inventory',
    id: 'rW8WBf',
  },
  enableReorderThresholdLabel: {
    description: 'Enable reorder threshold toggle label in V3 inventory tab',
    defaultMessage: 'Enable Reorder Threshold',
    id: 'xSdX6M',
  },
  reorderThreshold: {
    description: 'Inventory tracking reorder threshold label',
    defaultMessage: 'Reorder Threshold',
    id: 'AyH0U8',
  },
  allocationsOrderNumber: {
    description: 'Inventory allocations grid Order Number header',
    defaultMessage: 'Order Number',
    id: 'sWkFGi',
  },
  allocationsOrderStatus: {
    description: 'Inventory allocations grid Order Status header',
    defaultMessage: 'Order Status',
    id: '6aVZlN',
  },
  allocationsNumberAllocated: {
    description: 'Inventory allocations grid Number Allocated header',
    defaultMessage: 'Number Allocated',
    id: '8R1CSe',
  },
  allocationsTote: {
    description: 'Inventory allocations grid Tote column header',
    defaultMessage: 'Tote',
    id: '5Zcsra',
  },
  noLocations: {
    description: 'Inventory locations grid when there are no locations made',
    defaultMessage: 'No inventory locations have been made for this product',
    id: 'H8DiNf',
  },
  orderStatusUndefined: {
    description: 'Inventory allocations grid order status when finding an undefined value',
    defaultMessage: 'Undefined',
    id: 'gwhl1c',
  },
  altLocationButtonDisabled: {
    description: 'Tooltip message that informs user why the link to Alternate Locations modal is disabled',
    defaultMessage: 'Products must be saved and have a SKU to be assigned to alternate locations',
    id: 'dipcrP',
  },
  warehousesHeader: {
    description: 'Product details warehouse location',
    defaultMessage: 'Warehouses',
    id: 'qctzdT',
  },
  addInventoryActionMenu: {
    description: 'Add Inventory Action Menu Item',
    defaultMessage: 'Add Inventory',
    id: 'PFW6OV',
  },
  removeInventoryActionMenu: {
    description: 'Remove Inventory Action Menu Item',
    defaultMessage: 'Remove Inventory',
    id: '/k4qgk',
  },
  setInventoryActionMenu: {
    description: 'Set On-Hand Quantity Action Menu Item',
    defaultMessage: 'Set On-Hand Quantity',
    id: 'do+XWd',
  },
  moveInventoryActionMenu: {
    description: 'Move Inventory Action Menu Item',
    defaultMessage: 'Move Inventory',
    id: '6cLjbP',
  },
  historyActionMenu: {
    description: 'Inventory History Action Menu Item',
    defaultMessage: 'History',
    id: 'BqSOdP',
  },
  editLotActionMenu: {
    description: 'Edit Lot Action Menu Item',
    defaultMessage: 'Edit Lot',
    id: 'Ack62B',
  },
});
